import React from 'react';
import { Lock, CheckCircle2, User, GraduationCap } from 'lucide-react';

export default function Step2Pin({
  alunoPin, setAlunoPin, alunoPinInputRef, validarPin, pinValidated,
  alunoNome, alunoPeriodo, alunoTurno, alunoCodEsterilizacao
}) {
  return (
    <div className="flex flex-col items-center justify-center py-4 animate-fade-in w-full max-w-lg mx-auto">
      <div className="text-center mb-6">
        <h3 className="text-lg font-bold text-gray-800 mb-1 flex items-center justify-center gap-2">
          <Lock size={20} className="text-[#EAB308]" />
          Autenticação Necessária
        </h3>
        <p className="text-sm text-gray-500">Informe o PIN de 4 dígitos do aluno responsável.</p>
      </div>

      {!pinValidated ? (
        <div className="flex items-center justify-center gap-3 w-full">
          <input
            ref={alunoPinInputRef}
            type="password"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={4}
            placeholder="••••"
            value={alunoPin}
            onChange={e => setAlunoPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                validarPin();
              }
            }}
            className="w-24 text-center text-2xl tracking-[0.2em] font-mono border border-gray-300 rounded-lg px-2 py-2 focus:outline-none focus:border-[#EAB308] focus:ring-2 focus:ring-yellow-100 transition-all placeholder-gray-300"
          />
          <button
            onClick={validarPin}
            className="bg-[#0095DA] hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg font-medium text-sm flex items-center shadow-sm hover:shadow transition-all"
          >
            Validar PIN
          </button>
        </div>
      ) : (
        <div className="bg-green-50 border border-green-500 rounded-xl p-5 w-full shadow-sm animate-fade-in relative overflow-hidden">
          <div className="absolute -right-4 -top-4 opacity-10">
            <CheckCircle2 size={120} className="text-green-600" />
          </div>
          
          <div className="flex items-center gap-3 mb-4 relative z-10">
            <div className="bg-green-500 text-white p-1.5 rounded-full shadow-sm">
              <CheckCircle2 size={20} />
            </div>
            <h4 className="text-base font-bold text-green-800">Acesso Liberado!</h4>
          </div>
          
          <div className="space-y-2 text-sm text-green-900 relative z-10">
            <p className="flex items-center gap-2 font-semibold">
              <User size={16} className="text-green-600" />
              {alunoNome}
            </p>
            <p className="flex items-center gap-2">
              <GraduationCap size={16} className="text-green-600" />
              {alunoPeriodo || '—'} {alunoTurno ? `(${alunoTurno})` : ''}
            </p>
            <div className="mt-4 pt-3 border-t border-green-200 flex justify-between items-center">
              <span className="text-green-800 text-xs font-semibold">Cód. Esterilização:</span>
              <span className="font-mono bg-white px-2 py-1 rounded text-red-600 font-bold border border-green-200 shadow-sm text-xs">
                {alunoCodEsterilizacao || '—'}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}